import { formatCompactNumber } from '@openx/components-core/utils/formatCompactNumber';
import type { PackageEstimateRange } from '@openx/types/package';

export const getMarketRequestsRangeText = (estimate?: PackageEstimateRange | null): string | null => {
  if (!estimate) return null;

  // API sends value in millions by default
  const defaultMultiplier = 1_000_000;
  const parseValue = (estimate: string) => formatCompactNumber(Number(estimate) * defaultMultiplier).replace(' ', '');

  return `${parseValue(estimate.low)} - ${parseValue(estimate.high)}`;
};
